import "../../../../styles/screens/client-visit-details/manage-module/EventsListTable.css";
import "../../../../styles/screens/client-visit-details/manage-module/EventsList.css";
import { useDispatch, useSelector } from "react-redux";
import "../../../../styles/screens/client-visit-details/manage-module/SpeakersList.css";
import Loader from "../../../common-components/Loader";
import { faMagnifyingGlass } from "@fortawesome/free-solid-svg-icons";
import { ResourcesLabels } from "../../../../util/Strings";
import ErrorAlert from "../../../common-components/ErrorAlert";
import ErrorMessages from "../../../../util/ErrorMessages";
import ResourcesListTableBody from "./ResourcesListTableBody";
import BlackButton from "../../../custom-components/BlackButton";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from "react";
import ResourceCard from "../ResourceCard";
import { useEffect } from "react";
import { updateVisitResources } from "../../../../slices/VisitSlice";
import {
  getAllResources,
  getAllResourcesOfVisit,
  resetErrorAlert,
} from "../../../../slices/ResourcesSlice";
import CloseButton from "../../../custom-components/CloseButton";

function VisitResourcesList({ showModal, setShowModal }) {
  const dispatch = useDispatch();

  const updatedVisitResourcesData = useSelector(
    (state) => state.visits.updatedVisitData
  );
  const visitResourcesData = useSelector(
    (state) => state.resources.visitResourcesData
  );
  const selectedOfficeId = useSelector(
    (state) => state.officelist.selectedOfficeId
  );
  const [preSelctedIds, setPreSelectedIds] = useState([]);
  const id = useSelector((state) => state.visits.selectedVisitId);
  const data = useSelector((state) => state.resources.resources);
  const isLoading = useSelector((state) => state.resources.isLoading);
  const errorMessageCode = useSelector((state) => state.resources.errorCode);
  const [modalInput, setModalInput] = useState("");

  const onSelectHandler = (speakerId) => {
    let selectedIds = [...preSelctedIds];
    const index = selectedIds.indexOf(speakerId);
    if (index > -1) {
      selectedIds.splice(index, 1);
    } else {
      selectedIds.push(speakerId);
    }
    setPreSelectedIds(selectedIds);
  };

  function getVisitResourcesData() {
    dispatch(getAllResourcesOfVisit(id));
  }

  useEffect(() => {
    if (updatedVisitResourcesData && id) {
      getVisitResourcesData();
      dispatch(getAllResources(selectedOfficeId));
    }
  }, [updatedVisitResourcesData]);

  useEffect(() => {
    let preIds = visitResourcesData.map((item) => item._id.toString());
    setPreSelectedIds(preIds);
  }, [visitResourcesData]);

  const checkIsSelected = (speakerId) => {
    let index = preSelctedIds.indexOf(speakerId);
    return index > -1;
  };

  const onSubmitHandler = () => {
    setShowModal(false);
    let newData = { id: id, resources: preSelctedIds };
    dispatch(updateVisitResources(newData));
  };

  function handleCloseErrorAlert() {
    dispatch(resetErrorAlert(false));
  }

  if (isLoading) {
    return <Loader />;
  }

  if (errorMessageCode) {
    return (
      <ErrorAlert
        show={errorMessageCode}
        onClickHandle={handleCloseErrorAlert}
        title="Error"
        subTitle={ErrorMessages(errorMessageCode)}
      />
    );
  }

  return (
    <>
      <div className="events-list-container">
        <div className="events-list-content">
          {visitResourcesData && visitResourcesData.length > 0 ? (
            <table>
              <thead>
                <tr className="table-header">
                  <th>{ResourcesLabels.fileName}</th>
                  <th>{ResourcesLabels.description}</th>
                  <th>{ResourcesLabels.fileType}</th>
                  <th>{ResourcesLabels.uploadedFile}</th>
                  <th>{ResourcesLabels.thumbnailPhoto}</th>
                  <th>{ResourcesLabels.allowDownload}</th>
                </tr>
              </thead>
              {visitResourcesData.map((dataItem) => {
                return (
                  <ResourcesListTableBody
                    isVisit={true}
                    editMode={true}
                    dataItem={dataItem}
                  />
                );
              })}
            </table>
          ) : (
            <></>
          )}
        </div>
      </div>
      {showModal && (
        <div className="speaker-modal">
          <div className="speaker-form-scroll">
            <div className="speaker-form-flex">
              <div className="speaker-modal-content">
                <div style={{ justifySelf: "flex-end" }}>
                  <CloseButton
                    style={{ justifyContent: "flex-end" }}
                    onClickhandle={() => {
                      setShowModal(false);
                    }}
                  ></CloseButton>
                </div>
                <div className="modal-speaker-searchContainer">
                  <div className="speaker-searchIconText">
                    <FontAwesomeIcon
                      size="2xs"
                      icon={faMagnifyingGlass}
                      color="#D1D1D1"
                    />
                    <input
                      className="search"
                      icon="search"
                      placeholder="Search"
                      value={modalInput}
                      onChange={(e) => setModalInput(e.target.value)}
                    ></input>
                  </div>
                </div>
                <div className="speaker-submit-button">
                  <BlackButton onClickhandle={onSubmitHandler}>
                    Submit
                  </BlackButton>
                </div>
                <div className="speakers-list-body-modal">
                  {data &&
                    data
                      .filter((dataItem) => {
                        return modalInput.toLowerCase() === ""
                          ? dataItem
                          : dataItem?.title.toLowerCase().includes(modalInput);
                      })
                      .map((item) => {
                        return (
                          <ResourceCard
                            data={item}
                            key={item._id}
                            onSelectHandler={onSelectHandler}
                            isSelected={checkIsSelected(item._id)}
                          />
                        );
                      })}
                </div>
                {data.length === 0 && <div>No Resources Available</div>}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default VisitResourcesList;
